import React from 'react';

type Props = { children: React.ReactNode };

export function LightTitle({ children }: Props) {
    return <h3 className={'text-md font-semibold mb-3'}>{children}</h3>;
}
